import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "ncore-ui-kit";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "space-between",
        flexDirection: "column",
        flex: 1,
        ...webStyle({
            transition: "all 0.2s ease-in-out",
            cursor: "pointer"
        })
    },
    subDetailsContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    },
    cardHeader: {
        justifyContent: "space-between",
        alignItems: "flex-start",
        flexDirection: "row"
    },
    footerContainer: {
        justifyContent: "flex-end",
        flexDirection: "row",
        alignItems: "center"
    },
    iconContainer: {
        justifyContent: "center",
        alignItems: "center"
    },
    subDetailItem: {
        flexDirection: "column"
    },
    headerInfo: {
        flex: 1
    }
});
export default stylesheet;
